import { UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form } from 'src/registry/ui/Form';
import { BillingEntityFormSchemaValues } from 'src/features/billingEntity/utils/formSchema';
import { entityMessages } from 'src/features/entity/utils/messages';
import { billingMessages } from 'src/features/billingEntity/utils/messages';

type BillingEntityFormProps = {
    form: UseFormReturn<BillingEntityFormSchemaValues>;
    onSubmit: (values: BillingEntityFormSchemaValues) => void;
};

function BillingEntityForm({ onSubmit, form }: BillingEntityFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<BillingEntityFormSchemaValues>
                form={form}
                name="name"
                label={formatMessage(entityMessages.name)}
            />
            <InputFormField<BillingEntityFormSchemaValues>
                form={form}
                name="code"
                label={formatMessage(billingMessages.code)}
            />
            <InputFormField<BillingEntityFormSchemaValues>
                form={form}
                name="email"
                type="email"
                required={false}
                label={formatMessage(entityMessages.email)}
            />
            <InputFormField<BillingEntityFormSchemaValues>
                form={form}
                name="uic"
                label={formatMessage(billingMessages.legalNumber)}
            />
            <InputFormField<BillingEntityFormSchemaValues>
                form={form}
                name="tax_registration_number"
                required={false}
                label={formatMessage(billingMessages.taxNumber)}
            />
        </Form>
    );
}

export default BillingEntityForm;
